import { apiHubBaseUrl, request } from '@/libs/api-request'

function groupUrl (path) {
  return apiHubBaseUrl() + '/v1/journeymap/group' + path
}

/**
 * BA-6344에서 API Hub로 이전하면서 추가한 payload 호환 레이어입니다.
 * 기존 group 화면은 VAEX 계약에 맞춰 `sort`를 넘기고 있지만, 이전된 group API는
 * `sortBy`를 기대하므로 호출부를 한 번에 바꾸지 않고 API 경계에서만 변환합니다.
 */
function withSortBy (params = {}) {
  const { sort, ...rest } = params
  return {
    ...rest,
    ...(sort !== undefined ? { sortBy: sort } : {})
  }
}

/**
 * BA-6344에서 API Hub로 이전한 group list/search API용 payload 호환 레이어입니다.
 * UI의 list option 모델은 `pageNum`을 page size 값으로, `sort`를 정렬 값으로
 * 사용해 왔지만 API Hub는 이를 `pageSize`, `sortBy`로 받기 때문에
 * 기존 UI 계약은 유지하고 outgoing request payload만 정규화합니다.
 */
function withPaginationAndSortBy (params = {}) {
  const { pageNum, sort, ...rest } = params
  return {
    ...rest,
    ...(pageNum !== undefined ? { pageSize: pageNum } : {}),
    ...(sort !== undefined ? { sortBy: sort } : {})
  }
}

export function getGroupList (params, force) {
  let url = groupUrl('/get_group_list')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getHeatmapSubDomainList (params, force) {
  let url = '/ba/apply/heatmap/get_domain_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getHeatmapGroupList (params, force) {
  let url = '/ba/apply/heatmap/get_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getHeatmapDailyPvList (params, force) {
  let url = '/ba/apply/heatmap/get_heatmap_daily_pv_count'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTagList (params, force) {
  let url = groupUrl('/get_tag_list')

  const config = {
    method: 'post',
    url,
    data: withSortBy(params)
  }

  return request(config, force)
}

export function getUrlList (params, force) {
  let url = groupUrl('/get_url_list')

  const config = {
    method: 'post',
    url,
    data: withPaginationAndSortBy(params)
  }

  return request(config, force)
}

export function getGroupStat (params, force) {
  let url = groupUrl('/get_group_stat')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getSearch (params, force) {
  let url = groupUrl('/search')

  const config = {
    method: 'post',
    url,
    data: withPaginationAndSortBy(params)
  }

  return request(config, force)
}

export function setSchedule (params, force) {
  let url = groupUrl('/schedule_tag')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function upsertTag (params, force) {
  let url = groupUrl('/tag/create_or_update')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function deleteTag (params, force) {
  let url = groupUrl('/tag/delete')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function moveToTag (params, force) {
  let url = groupUrl('/tag/move_urls')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function checkTagDuplication (params, force) {
  let url = groupUrl('/tag/check_dup')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function upsertGroup (params, force) {
  let url = groupUrl('/create_or_update')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function duplicateGroup (params, force) {
  let url = groupUrl('/copy_group')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function deleteGroup (params, force) {
  let url = groupUrl('/delete')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getPalette (params, force) {
  let url = groupUrl('/get_palette')

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
